import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from "react-bootstrap";
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import {connect} from 'react-redux';
import { useTranslation } from 'react-i18next';

import {renameFolder as actionRenameFolder} from '../../actions/application';
import {renameFolder as serviceRenameFolder} from '../../services/folder';

export const FolderRenameDialog = ({
  folderToRename,
  cancel,
  renameFolder,
  userFolders
}) => {
  const { t } = useTranslation();
  const [nameValue, setNameValue] = useState('');
  const [error, setError] = useState('');
  const visible = folderToRename !== null;
  const folderName = folderToRename ? folderToRename.name : '';

  useEffect(() => {
    cancel();
  }, []);

  useEffect(() => {
    setNameValue(folderName);
  }, [folderName]);

  return (
    <Modal
      show={visible}
      onHide={() => {
        cancel();
        setError('');
      }}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="folder-create-modal"
    >
      <Modal.Header>
        <div className="folder-create-modal-header">
          <Modal.Title>{t('renameFolderDialog.title')}</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div id="folderCreate" className="form-group">
          <div className="d-flex justify-content-end mt-3">
            <span className="inter-bold-20 text-required">*</span>
            <span className="inter-regular-14 text-color-grey-600 ml-1">
              {t('general.required_field')}
            </span>
          </div>
          <div className="mb-2 mt-1">
            <div className="e-float-input type-text-input">
              <label className="inter-regular-16 label-field-text">
                {t("renameFolderDialog.folderNameLabel")}
                <span className="inter-bold-20 text-required ml-1">*</span>
              </label>
              <div className={`${error !== '' ? 'error' : ''}`}>
                <TextBoxComponent
                  id="name"
                  placeholder={t("renameFolderDialog.folderNameLabel")}
                  value={folderName}
                  change={e => {
                    setNameValue(e.value);
                  }}
                  input={e => {
                    setNameValue(e.value);
                  }}
                  className="field-input"
                />
              </div>

              {error !== '' && <div className="error-message">{error}</div>}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex justify-content-end modal-btn-container">
          <button
            type="button"
            className="mr-left font-weight-bold btn-outline-primary btn btn-secondary"
            onClick={() => {
              cancel();
              setError('');
            }}
          >
            {t('general.cancel')}
          </button>
          <button
            type="button"
            className="mr-left font-weight-bold btn-primary btn"
            onClick={async () => {
              const result = await renameFolder(folderToRename, nameValue, userFolders);
              if (!result.success) {
                setError(result.message);
              } else {
                setError('');
              }
            }}
            disabled={nameValue === ''}
          >
            {t('general.save')}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

FolderRenameDialog.propTypes = {
  application: PropTypes.object,
  folderToRename: PropTypes.object,
  cancel: PropTypes.func,
  renameFolder: PropTypes.func
};

FolderRenameDialog.defaultProps = {
};

const mapStateToProps = state => ({
  application: state.application,
  folderToRename: state.folders.explodedItems[state.application.renameFolderId] || null,
  lexon: state.lexon,
  email: state.login.formValues.user,
  userFolders: state.lexon.folders
});

const mapDispatchToProps = dispatch => ({
  cancel: () => dispatch(actionRenameFolder(null)),
  renameFolder: (user, folderToRename, newName, userFolders, lexon, email) =>
    serviceRenameFolder(
      dispatch,
      user, folderToRename,
      newName,
      userFolders,
      lexon,
      email
    )
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  (Object.assign({}, stateProps, dispatchProps, ownProps, {
    renameFolder: (folderToRename, newName, userFolders) =>
      dispatchProps.renameFolder(
        stateProps.application.user,
        folderToRename,
        newName,
        userFolders,
        stateProps.lexon,
        stateProps.email
      )
  }));

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(FolderRenameDialog);
